module.exports = __webpack_public_path__ + "media/images/board-mark-e2e86803.jpeg";